import React, { useState } from 'react';
import Helmet from 'react-helmet';
import SEO from '../../components/SEO';
import Layout from '../../layouts/index';

const LeaderCard = ({currentLeader, leader, handleLeader, position, description, why,superpower, firstJob, ingredient, image, linkedin, twitter}) => {
	
	return (
		<div className="leaders-container-item">
			<div className={`leader-card ${(currentLeader === leader) && "selectedLeader"}  `} onClick={() => handleLeader(leader)}>
				{/*<img src="/leadership/Leadership_Headshots_2021/Ty-Yamaguchi-office.jpeg"/>*/}
				<img src={image} alt="" />
				<div className="leaders-container-item-text">
					<h3>{ leader }</h3>
					<p className={`${(currentLeader === leader || currentLeader === "") ? "showText" : "hideText"}`} >{ position } </p>
				</div>
			</div>
			<div className={`informationContainer ${(currentLeader === leader) ? "showInformation" : "hideInformation"} information`}>
				<div className="leadContent">
					<div className="leadContent-text">
						<div className="information-description">
							<h3>Role</h3>
							<p>
								{description}
								
							</p>
						</div>
						{
							why &&
							<div>
								<h3>Why did you join ChartHop?</h3>
								<p>
									{ why }
								</p>
							</div>
						}
						{
							superpower &&
							<div>
								<h3>What’s your leadership superpower?</h3>
								<p>
									{ superpower }
								</p>
							</div>
						}
						{
							firstJob &&
							<div>
								<h3>What was your first job?</h3>
								<p>
									{ firstJob }
								</p>
							</div>

						}
						{
							ingredient &&
							<div>
								<h3>What’s the essential ingredient to a great team?</h3>
								<p>
									{ ingredient }
								</p>
							</div>
						}
					</div>
					<div className="icons-container">
						{
							linkedin &&
							<div className="social-media-logo">
								<a href={linkedin} target="_blank" rel="noopener noreferrer">
									<img src="/leadership/ch-linkedin.svg" alt="see the leaders linkedin" />
								</a>
							</div>
						}
						{
							twitter &&
							<div className="social-media-logo">
								<a href={twitter} target="_blank" rel="noopener noreferrer">
									<img src="/leadership/ch-twitter.svg" alt="see the leaders twitter" />
								</a>
							</div>

						}
					</div>


				</div>
				<div className="leadContent pin">
					<div className="leadContent-text">
						<div>
							<h3>{leader}, </h3><span>{" "}{position}</span>
							<p>
								{description}
								
							</p>
						</div>
						{
							why &&
							<div>
								<h3>Why did you join ChartHop?</h3>
								<p>
									{ why }
								</p>
							</div>
						}
						{
							superpower &&
							<div>
								<h3>What’s your leadership superpower?</h3>
								<p>
									{ superpower }
								</p>
							</div>
						}
						{
							firstJob &&
							<div>
								<h3>What was your first job?</h3>
								<p>
									{ firstJob }
								</p>
							</div>

						}
						{
							ingredient &&
							<div>
								<h3>What’s the essential ingredient to a great team?</h3>
								<p>
									{ ingredient }
								</p>
							</div>
						}
					</div>
				</div>
			</div>
		</div>
	)
}

const Leadership = (props) => {
	const location = props.location;
	const [leader, setLeader] = useState('');

	const handleLeader = (name) => {
		if(leader === name){
			setLeader('');
		} else {

			setLeader(name);
		}


	}

	return (
		<Layout bodyClass="leadership" ontouchstart>
			<SEO title="ChartHop Leadership" />
			<Helmet>
				<meta name="description" content="ChartHop is growing fast and dreaming big. Meet the leaders propelling us forward." />
				<meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
				<meta property="og:title" content="ChartHop Leadership" />
				<meta property="og:description" content="ChartHop is growing fast and dreaming big. Meet the leaders propelling us forward." />
				<meta property="og:image" content={`https://www.charthop.com/home/visualized.png`} />
				<meta property="og:type" content="website" />
				<meta property="og:locale" content="en_US" />
				<meta property="og:site_name" content="ChartHop" />
				{/* Twitter Card tags */}
				<meta name="twitter:title" content="ChartHop Leadership" />
				<meta name="twitter:description" content="ChartHop is growing fast and dreaming big. Meet the leaders propelling us forward." />
				<meta name="twitter:image" content={`https://www.charthop.com/home/visualized.png`} />
				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:site" content="@charthop" />
				<meta name="twitter:creator" content="@charthop" />
			</Helmet>
			<section className="intro container">
				<div className="row align-items-center justify-content-center">
					<div className="text-container">
						<div className="intro-title">
							<h1>
								Meet ChartHop’s <blueText>Leadership Team</blueText>
							</h1>
							<p>
								We’re growing fast and dreaming big. Meet the leaders propelling us forward.
							</p>
						</div>
					</div>
				</div>
			</section>

			{/*Ceo message*/}
			<section className="bgGrey">
				<div className="ceo container">
					<div className="ceo-title">
						<h2>How we got here: A note from founder and CEO Ian White</h2>
					</div>

					<div className="ceo-information">
						<div className="ceo-information-image">
							<img src="/company/careers/ian-photo.png" alt=""/>
						</div>
						<div className="ceo-information-text">

							<p>
								I founded ChartHop to create greater transparency and alignment in organizations.
							</p>

							<p>
								ChartHop is the platform that I wish I'd had, scaling the last company I founded. I knew there had to be a better way than pulling data manually into spreadsheets. Today we continue to grow and build on that platform to build the best people analytics software in the world.
							</p>

							<p>
								But even more important is forming and building a winning team — one that can collaborate, challenge each other, and push each other to be better. I'm proud of the team we've assembled on this mission — fast, inclusive, transparent and optimistic.
							</p>

							<p>
								Let's grow!
							</p>

							<div className="ceo-sign">
								<img src="/company/careers/signature.png" alt=""/>
							</div>
						</div>
					</div>
				</div>
			</section>

			{/*Our leaders*/}
			<section className="leaders container">
				<div className="leaders-title">
					<h2>Our leaders</h2>
				</div>
				<div className="leaders-container">

					<LeaderCard 
						currentLeader={leader} 
						handleLeader={handleLeader}
						image={"/leadership/Leadership_Headshots_2021/Ian-White-office.jpg"}
						linkedin={"https://www.linkedin.com/in/ianbwhite/"}
						twitter={"https://twitter.com/eonwhite"}
						leader={"Ian White"}
						position={"CEO and founder"}
						description={`Ian’s role is to hire a team that can win, ensure everyone is clear on what ChartHop is trying to achieve, and create an iconic product and company.`}
						why={""}
						superpower={"Solving complex problems with speed, vision, and creativity."}
						firstJob={""}
						ingredient={"Trust is the foundation of a great team — with trust, you can move faster, respectfully challenge each other, and accomplish great things."}
					/>

					<LeaderCard 
						currentLeader={leader} 
						handleLeader={handleLeader}
						image={"/leadership/Leadership_Headshots_2021/matt_wolf.png"}
						linkedin={"https://www.linkedin.com/in/mpwolf/"}
						twitter={""}
						leader={"Matt Wolf"}
						position={"Chief Financial Officer"}
						description={"Matt’s role is to help ChartHop accomplish its company growth goals with predictable, transparent metrics and world-class execution."}
						why={"ChartHop is a company unlike any other. The combination of its incredible company culture, commitment to workplace transparency, and an unparalleled approach to visualizing employee insights initially attracted me to the role."}
						superpower={""}
						firstJob={""}
						ingredient={"Communication. Open communication is necessary to build trust, overcome challenges and achieve successful outcomes."}
					/>


					<LeaderCard 
						currentLeader={leader} 
						handleLeader={handleLeader}
						image={"/leadership/Leadership_Headshots_2021/Diana-Kucer-office.jpeg"}
						linkedin={"https://www.linkedin.com/in/dianakucer/"}
						twitter={""}
						leader={"Diana Kucer"}
						position={"Chief Marketing Officer"}
						description={"Diana leads ChartHop's global marketing strategy and execution. She focuses on all things brand, growth, and market positioning to attract and delight customers."}
						why={""}
						superpower={"Compassion. I truly enjoy helping my team live their best lives and do their best work, and it all starts with understanding and respecting the human side."}
						firstJob={""}
						ingredient={"Trust. It drives the human connection that forms the foundation of any team."}
					/>

					<LeaderCard 
						currentLeader={leader} 
						handleLeader={handleLeader}
						image={"/leadership/Leadership_Headshots_2021/Emily-Connery-Office.jpeg"}
						linkedin={"https://www.linkedin.com/in/emily-connery-870b6634/"}
						twitter={""}
						leader={"Emily Connery"}
						position={"VP, People and Talent"}
						description={"Emily is focused on driving organizational effectiveness through recruitment, development, and employee engagement. She is ChartHop’s champion of company culture and DEI, the facilitator of cross-team communication, and coach to the management team."}
						why={"As ChartHop’s second customer, I’ve been a believer in the product’s impact since the beginning."}
						superpower={""}
						firstJob={""}
						ingredient={"Trust. If people trust, they will challenge each other and support each other, ensuring continuous collaboration."}
					/>

					<LeaderCard 
						currentLeader={leader} 
						handleLeader={handleLeader}
						image={"/leadership/Leadership_Headshots_2021/Sarah-Diegnan-office.jpeg"}  
						linkedin={"https://www.linkedin.com/in/sarahdiegnan/"}
						twitter={""}
						leader={"Sarah Diegnan"}
						position={"VP, Customer Experience"}
						description={"Sarah leads ChartHop’s customer journey, partnering with customers from the first moments of onboarding through successful execution of all account goals to make sure customers get the most out of ChartHop."}
						why={"Because of the people and the product. In the Customer Experience world, your team is the most important asset and I saw how ChartHop could help me as a leader unlock the true potential of my team."}
						superpower={"Hiring a team of customer-facing professionals that truly complement each other and then organizing them in a way where the sum of the parts is greater than the whole."}
						firstJob={""}
						ingredient={""}
					/>

					<LeaderCard 
						currentLeader={leader} 
						handleLeader={handleLeader}
						image={"/leadership/Leadership_Headshots_2021/Justin_Garrity_V1.png"} 
						linkedin={"https://www.linkedin.com/in/justinogarrity/"}
						twitter={"https://twitter.com/justinogarrity"}
						leader={"Justin Garrity"}
						position={"VP, Product"}
						description={"Justin is responsible for supporting and building the product management team that will shape the roadmap of the ChartHop offering, maximizing value and productivity for all users."}
						why={""}
						superpower={"I genuinely care about my team and our customers. I want both of them to be wildly successful."}
						firstJob={""}
						ingredient={"Using the product ourselves every single day."}
					/>

					<LeaderCard 
						currentLeader={leader} 
						handleLeader={handleLeader}
						image={"/leadership/Leadership_Headshots_2021/JT-Levin-office.jpg"}
						linkedin={"https://www.linkedin.com/in/jtlevin/"}
						twitter={""}
						leader={"J.T. Levin"}
						position={"VP, Sales"}
						description={"J.T. is responsible for building, coaching, and managing a team of sales reps and BDRs who help HR professionals understand how ChartHop can dramatically improve the way they work and do their jobs."}
						why={""}
						superpower={""}
						firstJob={"A restaurant in San Diego that served Chicago style hot dogs and Italian beef, Chicago on a Bun. The owners could not have been meaner and it taught me a lot about leadership and treating people fairly and equitably."}
						ingredient={"People feeling empowered to be both self-sufficient and comfortable leaning on each other for help whenever they need it."}
					/>

					<LeaderCard 
						currentLeader={leader} 
						handleLeader={handleLeader}
						image={"/leadership/Leadership_Headshots_2021/Julie-Sommerville-office.jpeg"}
						linkedin={"https://www.linkedin.com/in/juliesommerville/"}
						twitter={"https://twitter.com/juliesommervill"}
						leader={"Julie Sommerville"}
						position={"VP, Engineering"}
						description={"Julie runs the Product and Engineering teams at ChartHop, leading the vision to build world class software that delights our customers."}
						why={"I immediately saw the value in the product and was thrilled to work with Ian again."}
						superpower={""}
						firstJob={""}
						ingredient={"Good communication around goals and priorities, respect, and a healthy dose of humor."}
					/>

					<LeaderCard 
						currentLeader={leader} 
						handleLeader={handleLeader}
						image={"/leadership/Leadership_Headshots_2021/Ty-Yamaguchi-office.jpeg"} 
						linkedin={"https://www.linkedin.com/in/tyron/"}
						twitter={"https://twitter.com/1k4"}
						leader={"Ty Yamaguchi"}
						position={"VP, User Experience"}
						description={"Ty oversees the design, research, and technical communications that go into ChartHop’s core product."}
						why={""}
						superpower={"Caring for people and doing my best to motivate them."}
						firstJob={"A web designer for a tiny boutique agency doing Flash & HTML."}
						ingredient={""}
					/>

				</div>
			</section>

			{/*Conclusion*/}
			<section className="bgGrey">
				<div className="conclusion container">
					<div className="conclusion-content">
						<h2 className="text-center">Interested in joining our team?</h2>
						<a className="button primary join-team" href="/company/job-openings/" target="_blank">
							SEE OPEN ROLES
						</a>
					</div>
				</div>
			</section>
		</Layout>
	);
};


export default Leadership;